module.exports = __webpack_public_path__ + "fonts/Rubik-500-cyrillic72.3ecd4ac.woff2";